import { StyledMenu, StyledMenuItem } from '@fountain/fountain-ui-components';
import useToggleStyles from '@fountain/fountain-ui-components/dist/Buttons/ToggleButton/styles';
import { Button, MenuItemProps, MenuProps } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { ReactNode } from 'react';

import { useStyles } from './styles';

// Narrows FUI's menu primitives to MUI's own `MenuProps` and `MenuItemProps`.
const Menu = StyledMenu as React.ComponentType<MenuProps>;
export const FilterMenuItem =
  StyledMenuItem as React.ComponentType<MenuItemProps>;

interface Props {
  label: string;
  name: string;
  narrowed: boolean;
  anchor: HTMLButtonElement | null;
  onOpen: (anchor: HTMLButtonElement) => void;
  onClose: () => void;
  children: ReactNode;
  dialog?: boolean;
  autoFocus?: boolean;
}

// FUI's dropdown only accepts strings; custom date fields and search need its menu primitives.
export const ConversationFilterMenu = ({
  label,
  name,
  narrowed,
  anchor,
  onOpen,
  onClose,
  children,
  dialog = false,
  autoFocus = true,
}: Props) => {
  const classes = useToggleStyles(narrowed);
  const styles = useStyles();
  return (
    <>
      <Button
        className={classes.btn}
        aria-label={`${name}: ${label}`}
        aria-haspopup={dialog ? 'dialog' : 'menu'}
        aria-expanded={!!anchor}
        onClick={event => onOpen(event.currentTarget)}
      >
        <span className={styles.filterLabel}>{label}</span>
        <ExpandMoreIcon className={classes.arrow} fontSize="small" />
      </Button>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={onClose}
        className={classes.menu}
        disableEnforceFocus={dialog}
        autoFocus={autoFocus}
        MenuListProps={{
          'aria-label': name,
          ...(dialog
            ? {
                role: 'dialog',
                component: 'div',
                onKeyDown: (event: React.KeyboardEvent) => {
                  if (event.key === 'Tab') event.stopPropagation();
                },
              }
            : {}),
        }}
      >
        {children}
      </Menu>
    </>
  );
};
